import React from 'react';
import { GlobalDataContext } from './provider';

function withGlobalData(Component) {
  return function WrapperComponent(props) {
    return (
      <GlobalDataContext.Consumer>
        {data => <Component {...props} {...data} />}
      </GlobalDataContext.Consumer>
    );
  };
}

export default withGlobalData;
